import { GET_INITIAL_CONFIG, GET_INITIAL_CONFIG_ERROR, GET_INITIAL_CONFIG_SUCCESS } from './TopNavbar.actions'

const topNavbarState = { error: null, loading: true }

/**
 * The top navbar's reducer.
 */
const topNavbarReducer = (state = topNavbarState, { payload, type }) => {
  switch (type) {
    case GET_INITIAL_CONFIG: {
      return { ...state, loading: true }
    }
    case GET_INITIAL_CONFIG_ERROR: {
      return { ...state, loading: false }
    }
    case GET_INITIAL_CONFIG_SUCCESS: {
      return { ...state, ...payload, loading: false }
    }
    default: {
      return state
    }
  }
}

export default topNavbarReducer
